import ArchiveGallery from "./ArchiveGallery";

function Favorites() {
  return (
    <ArchiveGallery
      category="all"
      favoritesOnly
      collectionLabel="Collections"
      emptyTitle="You have not marked any artwork as a favourite yet."
    />
  );
}

export default Favorites;
